import React from 'react';
import PropTypes from 'prop-types';

import { sanitizeQuery } from '../../utils/sanatize';

import styles from './AccountTypeDetails.css';

const AccountTypeDetails = ({
    header,
    secondaryHeader,
    description,
    nasuURL
}) => (
    <a
        href={`${nasuURL}?${sanitizeQuery(window.location.search)}`}
        className="details-link"
    >
        <span
            className={
                secondaryHeader
                    ? 'details-wrapper title-padding'
                    : 'details-wrapper'
            }
        >
            <span
                className={
                    secondaryHeader
                        ? 'details-title split-heading'
                        : 'details-title'
                }
            >
                {header}
            </span>
            {secondaryHeader && (
                <span
                    id="secondaryHeader"
                    className="details-title split-heading"
                >
                    {secondaryHeader}
                </span>
            )}
            <span className="description">{description}</span>
        </span>
        <style jsx>{styles}</style>
    </a>
);

AccountTypeDetails.propTypes = {
    header: PropTypes.node.isRequired,
    description: PropTypes.node.isRequired
};

export default AccountTypeDetails;
